import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app';
import { appConfig } from '@app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((_err) => {
  // intentionally ignored console.error(_err)
  console.error('bootstrapApplication error');
});
